import React from 'react'
import { Text, Grid, csx } from '@vtex/admin-ui'
import { DeliveryMethodLabel } from './DeliveryMethodLabel'
import { FormattedMessage } from 'react-intl'
import { DeliveryChannel, getDeliveryMethodLabelData } from './utils'
import { useProductPageOffersSection } from './hooks'
import Price from '@/checkout-instore-legacy/components/Commons/Price'

export type ProductPageOffersSectionProps = {
  skus: Item[] | undefined
  selectedSku: Item | undefined
}

export const ProductPageOffersSection = ({
  skus = [],
  selectedSku,
}: ProductPageOffersSectionProps) => {
  const {
    hasTakeAwayAndAnotherMethod,
    otherDeliveryMethod,
    showThirdPartyLabel,
  } = useProductPageOffersSection({
    skus,
    selectedSku,
    isAllVariationsSelected: true,
  })

  if (
    !hasTakeAwayAndAnotherMethod ||
    !otherDeliveryMethod.otherPurchaseConditions.deliveryChannels
  ) {
    return null
  }

  return (
    <div
      data-testid="product-page-offers-section"
      className={csx({
        border: '$neutral',
        borderRadius: '$base',
        marginTop: '$space-4',
      })}
    >
      <div
        className={csx({
          padding: '$space-4',
          background: '#F4F4F4', // [TODO]<theme>: $gray05
        })}
      >
        <Text variant="action1" className={csx({ display: 'block' })}>
          <FormattedMessage id="offers.title" />
        </Text>
        <Text
          variant="detail"
          className={csx({ display: 'block', color: '#545454' })}
        >
          <FormattedMessage id="offers.subtitle" />
        </Text>
      </div>
      <div className={csx({ padding: '$space-4' })}>
        <Text
          variant="detail"
          className={csx({
            display: 'block',
            color: '#545454', // [TODO]<theme>: $gray50
          })}
        >
          <FormattedMessage id="insights.startingAt" />
        </Text>
        {/* // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore */}
        <Price
          className="f5 fw7 mt1"
          value={otherDeliveryMethod.otherPurchaseConditions.priceInCents}
        />

        <Grid templateColumns="1fr" className={csx({ marginTop: '$space-2' })}>
          {otherDeliveryMethod.otherPurchaseConditions.deliveryChannels.map(
            (deliveryChannel: DeliveryChannel) => {
              const data = getDeliveryMethodLabelData(deliveryChannel)

              return (
                <DeliveryMethodLabel key={deliveryChannel} Icon={data.Icon}>
                  {data.text}
                </DeliveryMethodLabel>
              )
            }
          )}
          {showThirdPartyLabel && (
            <DeliveryMethodLabel>
              <FormattedMessage id="offer.3p" />
            </DeliveryMethodLabel>
          )}
        </Grid>
      </div>
    </div>
  )
}
